import { action, observable, runInAction, makeObservable } from 'mobx';
import api from './../api';

export default class SendTaskEmailStore {
  isSending = false;

  email = {
    to: "",
    subject: "",
    message: ""
  };

  errors = [];

  constructor() {
    makeObservable(this, {
      isSending: observable,
      email: observable,
      errors: observable,
      setEmail: action,
      setSubject: action,
      setMessage: action,
      sendEmail: action
    });
  }

  setEmail(address) {
    this.errors = [];
    this.email.to = address;
  }
  setSubject(subject) {
    this.errors = [];
    this.email.subject = subject;
  }
  setMessage(message) {
    this.errors = [];
    this.email.message = message;
  }

  sendEmail(taskId) {
    console.log('send email task id', taskId);
    this.errors = [];
    let to;
    if(!this.email.to.trim().length){
      this.errors.push('Please enter a email address.');
      return;
    }else{
      to = this.email.to.split(',').map(e => e.trim());
      if(to.filter(e => !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(e)).length){
        this.errors.push('Please verify all email addresses are correct.');
        return;
      }
    }
    if(!this.email.subject.trim().length){
      this.errors.push('Please enter a subject.');
      return;
    }
    if(!this.email.message.trim().length){
      this.errors.push('Please enter a message.');
      return;
    }
    this.isSending = true;
    return api.sendExternalTaskEmail(taskId, {...this.email, to}).then(() => {
      runInAction(() => {
        this.isSending = false;
        this.email = {
          to: "",
          subject: "",
          message: ""
        };
      })
    });
  }
}